import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { FullScreenLoader } from "@/components/common/Loader";
import { leaveApp, loginRoute, panelTenant } from "@/lib/tenantPath";

const AuthCtx = createContext(null);

export const homeFor = (role) => (role === "super_admin" ? "/super-admin" : role === "barber" ? "/barbeiro" : "/admin");

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.removeItem("bf_business_id");
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("bf_business_id");
    setUser(false);
  }, []);

  return <AuthCtx.Provider value={{ user, setUser, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function RequireRole({ roles, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <FullScreenLoader />;
  // the login lives inside each app scope (/t/<slug>/admin/login), otherwise the installed PWA would
  // open in a browser tab with the URL bar visible
  if (!user) return <Navigate to={`${loginRoute()}?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (!roles.includes(user.role)) {
    if (panelTenant()) {
      leaveApp(homeFor(user.role), true);
      return <FullScreenLoader />;
    }
    return <Navigate to={homeFor(user.role)} replace />;
  }
  return children;
}
